import React from 'react'
import { Box, Typography } from '@material-ui/core'

import useStyles from './styles'

const EmailTopBar = ({ title }) => {
  const classes = useStyles()

  return (
    <Box className={classes.topBar}>
      <Typography className={classes.topBarTitle}>{title}</Typography>
    </Box>
  )
}

export default EmailTopBar
